export interface IProject {
  id?: number;
  name: string;
  is_blocked?: boolean;
  comments?: string;
  start_date?: string;
  create_date?: string;
  payback: string;
  rating: number;
  irr?: number | string;
  currency_multiplication?: number | string;
  currency?: number | string;
  npv?: number | string;
}
